import React from 'react';

class CountryAssistanceOECDPanel extends React.Component {
  render() {
    const { id, header, children } = this.props;

    return (
      <div className="panel panel-default assistance-page-panel" id={ id }>
        <div className="panel-heading">
          <h3 style={{ display: 'inline' }}>
            { header }
          </h3>
          <span className="pull-right">Data source: OECD database</span>
        </div>
        <div className="panel-body">
          { children }
        </div>
      </div>
    );
  }
}

export default CountryAssistanceOECDPanel;



// WEBPACK FOOTER //
// ./src/components/CountryAssistance/CountryAssistanceOECDPanel.js